import { Grid, Typography, makeStyles } from '@material-ui/core';
import { CardTick1 } from 'iconsax-react';

const useStyles = makeStyles(() => ({
	containerOnline: {
		backgroundColor: '#F1F4F8',
		borderRadius: '12px',
		padding: '8px 12px',
		marginTop: '16px',
		display: 'flex',
		justifyContent: 'space-between',
	},
	titleOnline: {
		fontSize: '14px',
		fontWeight: 700,
		color: '#272466',
		display: 'flex',
		alignItems: 'center',
	},
	subTitleOnline: {
		fontSize: '14px',
		fontWeight: 500,
		color: '#272466',
	},
}));

const PaymentMethod = ({ method }) => {
	const classes = useStyles();
	return (
		
<Grid item xs={12} className={classes.containerOnline}>
					<Typography className={classes.titleOnline}>
						<CardTick1 size="20" color="#272466" style={{ marginLeft: '4px' }} />
						شیوه پرداخت:
					</Typography>
					<Typography className={classes.subTitleOnline}>{method}</Typography>
				</Grid>
	);
};

export default PaymentMethod;

